import httpRequest from 'httpRequest'
import {
    ProductContract,
    ItemContract,
    ProductSlimModel,
    UpsertProductResultContract,
    EntityLink,
    ComboBuilderProduct,
    LinkedModifierSlim,
    ProductExportContract,
    ProductPriceListSlimModel,
} from 'models'
import pathWithQuery from 'utilities/queryParams'

const PRODUCT_PREFIX = '/company/products'

const productService = {
    getProducts(variantItem: boolean = false) {
        return httpRequest.get<ProductContract[]>(
            pathWithQuery({ variantItem }, PRODUCT_PREFIX),
        )
    },
    async getProductsWithVariants() {
        return httpRequest.get<ProductContract[]>(
            pathWithQuery({ variantItem: true }, PRODUCT_PREFIX),
        )
    },
    async getProductsWithVariantsAndCombo() {
        return httpRequest.get<ProductContract[]>(
            pathWithQuery(
                { variantItem: true, comboItem: true },
                PRODUCT_PREFIX,
            ),
        )
    },

    getProductLookupList(
        variantItem: boolean = false,
        comboItem: boolean = false,
    ) {
        return httpRequest.get<ProductSlimModel[]>(
            pathWithQuery(
                { variantItem, comboItem },
                `${PRODUCT_PREFIX}/lookup-list`,
            ),
        )
    },
    getProduct(id: string) {
        return httpRequest.get<ItemContract>(`${PRODUCT_PREFIX}/${id}`)
    },
    getDependencies(productID: string) {
        return httpRequest.get<EntityLink>(
            `${PRODUCT_PREFIX}/dependency/${productID}`,
        )
    },
    createProduct(payload: ItemContract) {
        return httpRequest.post<UpsertProductResultContract>(
            PRODUCT_PREFIX,
            payload,
        )
    },
    updateProduct(id: string, payload: ItemContract, isForceCombo: boolean) {
        return httpRequest.put<UpsertProductResultContract>(
            `${PRODUCT_PREFIX}/${id}`,
            payload,
            { params: { isForceCombo } },
        )
    },
    deleteProducts(productIDs: string[]) {
        return httpRequest.delete(`${PRODUCT_PREFIX}`, {
            params: { productIDs },
        })
    },
    updateFlag(
        productID: string,
        flagName: string,
        flagValue: boolean,
        isForceCombo: boolean = false,
    ) {
        return httpRequest.put(
            `${PRODUCT_PREFIX}/${productID}/update-flag`,
            {},
            {
                params: {
                    productID,
                    flagName,
                    flagValue,
                    isForceCombo,
                },
            },
        )
    },
    getProductForPriceList: () => {
        return httpRequest.get<ProductPriceListSlimModel[]>(
            `${PRODUCT_PREFIX}/pricelist-products`,
        )
    },
    getCountAppliedModifierToAllProducts: () =>
        httpRequest.get<{ [key: string]: number }>(
            `${PRODUCT_PREFIX}/modifier-group-count`,
        ),
    getProductModifiers: (productID: string) =>
        httpRequest.get<LinkedModifierSlim[]>(
            `${PRODUCT_PREFIX}/${productID}/modifiers`,
        ),
    importProduct: (formData: FormData) =>
        httpRequest.post(`${PRODUCT_PREFIX}/import`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    initLocationData: (productID: string) =>
        httpRequest.post(`${PRODUCT_PREFIX}/init-location-data/${productID}`),
    getComboBuilderProducts: () =>
        httpRequest.get<ComboBuilderProduct[]>(
            `${PRODUCT_PREFIX}/for-combo-builder`,
        ),
    getExportProduct: () =>
        httpRequest.get<ProductExportContract[]>(`${PRODUCT_PREFIX}/export`),
}

export default productService
